import React from 'react';

const RenderMultilineText: React.FC<{ text: string }> = ({ text }) => {
  const content = text.split('\n').map((l, id) => (
    <span key={l}>
      {l}
      <br />
    </span>
  ));
  return <div>{content}</div>;
};

export default RenderMultilineText;
